const CATEGORY_MAP = {
  AROUND: "주변기기",
  LOGIN: "로그인/접속",
  PROGRAM: "프로그램",
  ID: "신분증",
};

export const qnaCategory = (input) => {
  return CATEGORY_MAP[input] || "기타";
};
